import * as React from 'react';
import { Flex } from '@workday/canvas-kit-react/layout';
import { styled, createComponent } from '@workday/canvas-kit-react/common';
const StyledList = styled(Flex.as('ul'))({
    listStyle: 'none',
});
export const List = createComponent('ul')({
    displayName: 'List',
    Component: ({ children, ...elemProps }, ref, Element) => {
        return (React.createElement(StyledList, Object.assign({ as: Element, marginY: "zero", marginX: "zero", padding: "zero", ref: ref }, elemProps), children));
    },
});
export const ListItem = createComponent('li')({
    displayName: 'ListItem',
    Component: ({ children, ...elemProps }, ref, Element) => {
        return (React.createElement(Flex, Object.assign({ as: Element, ref: ref }, elemProps), children));
    },
});
